<div class="qvs-info-box">
  <div class="qvs-info-box__box" [ngClass]="{ 'qvs-info-box__box__justified': title }">
    <div class="qvs-info-box__box__icon" [ngClass]="{ 'qvs-info-box__box__icon__centered': title }">
      <qvs-svg-icon *ngIf="!title" [src]="'assets/images/info-icon.svg'"></qvs-svg-icon>
      <qvs-svg-icon *ngIf="title" [src]="'assets/images/info-icon-round.svg'"></qvs-svg-icon>
    </div>
    <div class="qvs-info-box__box__container">
      <div *ngIf="title" class="qvs-info-box__box__container__title" [innerHTML]="title"></div>
      <div *ngIf="title" class="qvs-info-box__box__container__subtext" [innerHTML]="text"></div>
      <div *ngIf="!title" class="qvs-info-box__box__container__text" [innerHTML]="text"></div>
    </div>
    <qvs-svg-icon
      *ngIf="closable"
      class="qvs-info-box__box__close-icon"
      [src]="'assets/images/close.svg'"
      [title]="'close-icon'"
    ></qvs-svg-icon>
  </div>
</div>
